import { Users } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function GetMembersNode({ id, data, selected }) {
  const parts = [];
  if (data.filterField && data.filterField !== 'All') {
    parts.push(`${data.filterField} ${data.filterOperator || '='} ${data.filterValue || '?'}`);
  }
  if (data.limit) parts.push(`Limit: ${data.limit}`);
  const summary = parts.length > 0 ? parts.join(' | ') : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.wallettwo}
      icon={Users}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
      {data.filterField === 'All' && (
        <span className="inline-block mt-1 text-[10px] font-medium bg-cyan-100 text-cyan-700 px-2 py-0.5 rounded-full">
          All members
        </span>
      )}
    </BaseNode>
  );
}
